import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/core/services/configuration/configuration.service';

@Component({
  selector: 'app-manage-tipodetalles-modal',
  templateUrl: './manage-tipodetalles-modal.component.html',
  styleUrls: ['./manage-tipodetalles-modal.component.css']
})
export class ManageTipodetallesModalComponent implements OnInit {

  myForm: FormGroup;
  @Input() evaluacionId = 0;
  evaluacion: any;

  @Output() successEmit: EventEmitter<any> = new EventEmitter<any>();
  faTimes = faTimes
  constructor(
    public formbuild          : FormBuilder,
    public activeModal        : NgbActiveModal,
    private configurationService	: ConfigurationService,
  ) {
    this.initForm();
   }

  ngOnInit(): void {
    if (this.evaluacionId) {
      this.obtenerTipoDetalle();
    }
  }

  initForm() {
    this.myForm = this.formbuild.group({
      descripcion: [null, [Validators.required]]
    });
  }
  
  setForm(item) {
    for (const key in item) {
      if (this.myForm.controls[key]) {
        this.myForm.controls[key].setValue(item[key]);
      }
    }
  }

  obtenerTipoDetalle() {
    this.configurationService.obtenerTipoDetalle(this.evaluacionId)
    .then(res => {
      this.evaluacion = res;
      this.setForm(res);
    })
    .catch(error => {
      console.error(error);
    });
  }

  onSubmit() {
    if(this.myForm.valid) {
      const data = this.myForm.value;

      this.configurationService.guardarTipoDetalle(this.myForm.value, this.evaluacionId)
      .then(res => {
        this.successEmit.emit();
        this.activeModal.close(true);
      }).
      catch(error => {
        console.log(error);
        // this.activeModal.close(false);
      });
    }
  }
}
